const reports = {
	inventory: {
		model: null,
		filterOptions: [
			{ column: 'created_on', displayName: 'Created At', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' },
			{
				column: 'expiration_date',
				displayName: 'Expires',
				type: 'datetime'
			}
		],
		endpoint: { table: 'drug', method: 'not_used' },
		downloadURI: '/api/v1/drug/not/used',
		date_field: 'expiration_date',
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires On', type: 'date' },
			created_on: { label: 'Created At', type: 'datetime' }
		}
	},
	'inventory-for-all-agencies': {
		model: null,
		multiAgency: true,
		filterOptions: [
			{ column: 'created_on', displayName: 'Created', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' },
			{
				column: 'expiration_date',
				displayName: 'Expires',
				type: 'datetime'
			}
		],
		endpoint: { table: 'drug', method: 'not_used' },
		downloadURI: '/api/v1/drug/not/used',
		date_field: 'expiration_date',
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			user_group__name: { label: 'Agencies' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' },
			created_on: { label: 'Created At', type: 'datetime' }
		}
	},
	'wasted-for-all-agencies': {
		model: null,
		multiAgency: true,
		filterOptions: [
			{ column: 'created_on', displayName: 'Wasted At', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' }
		],
		endpoint: { table: 'stock_move_record', method: 'wasted' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			user_group__name: { label: 'Agency' },
			lot_number: { label: 'Lot Number' },
			created_on: { label: 'Date', type: 'datetime' },
			user_name: { label: 'Wasted By' },
			notes: { label: 'Waste Reason' },
			witness_name: { label: 'Verified By' }
		}
	},
	'administered-for-all-agencies': {
		model: null,
		multiAgency: true,
		filterOptions: [
			{ column: 'created_on', displayName: 'Administered', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' }
		],
		endpoint: { table: 'stock_move_record', method: 'administeredOfficial' },
		downloadURI: '/api/v1/stock_move_record/administered/official',
		date_field: 'created_on',
		sort: { column: 'created_on', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			user_group__name: { label: 'Agency' },
			lot_number: { label: 'Lot Number' },
			created_on: { label: 'Date', type: 'datetime' },
			user_name: { label: 'Administered By' },
			witness_name: { label: 'Verified By' }
		}
	},
	supply: {
		model: 'drug',
		endpoint: null,
		date_field: 'expiration_date',
		sort: { column: 'expiration_date', direction: 'desc' },
		filter: { column: 'unit__type', comparison: '=', value: 'supply' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' }
		}
	},
	fentanyl: {
		model: 'drug',
		endpoint: null,
		date_field: 'expiration_date',
		filter: { column: 'type', comparison: '=', value: 'fentanyl' },
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage ', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' }
		}
	},
	versed: {
		model: 'drug',
		endpoint: null,
		date_field: 'expiration_date',
		filter: { column: 'type', comparison: '=', value: 'versed' },
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' }
		}
	},
	morphine: {
		model: 'drug',
		endpoint: null,
		date_field: 'expiration_date',
		filter: { column: 'type', comparison: '=', value: 'morphine' },
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' }
		}
	},
	drug_box: {
		model: 'drug',
		endpoint: null,
		date_field: 'expiration_date',
		filter: { column: 'drug_box_id', comparison: '=', value: ':drug_box_id' },
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' }
		}
	},
	unit: {
		model: null,
		endpoint: { table: 'drug', method: 'forUnit' },
		downloadURI: '/api/v1/drug/unit/for',
		date_field: 'expiration_date',
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			stock_move_record__quantity: { label: 'Dosage', type: 'volume' },
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires', type: 'date' }
		}
	},
	administered: {
		model: null,
		filterOptions: [
			{ column: 'created_on', displayName: 'Administered At', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' }
		],
		endpoint: { table: 'stock_move_record', method: 'administeredOfficial' },
		downloadURI: '/api/v1/stock_move_record/administered/official',
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			unit__name: { label: 'Unit' },
			quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			paired_quantity: {
				label: 'Waste',
				type: 'volume',
				alteration: function(v) {
					if (v) {
						return Math.abs(parseFloat(v));
					}
					return 0;

				}
			},
			lot_number: { label: 'Lot Number' },
			created_on: { label: 'Date', type: 'datetime' },
			user_name: { label: 'Administered By' },
			witness_name: { label: 'Verified By' }
		}
	},
	wasted: {
		model: null,
		filterOptions: [
			{ column: 'created_on', displayName: 'Wasted At', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' }
		],
		endpoint: { table: 'stock_move_record', method: 'wasted' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			unit__name: { label: 'Unit' },
			quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			lot_number: { label: 'Lot Number' },
			created_on: { label: 'Date', type: 'datetime' },
			user_name: { label: 'Wasted By' },
			notes: { label: 'Waste Reason' },
			witness_name: { label: 'Verified By' }
		}
	},
	'drug-transfer': {
		model: null,
		filterOptions: [
			{ column: 'created_on', displayName: 'Transferred At', type: 'datetime' },
			{ column: 'type', displayName: 'Drug Type', options: 'will be set by component' }
		],
		endpoint: { table: 'drug_transfer', method: 'report' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			created_on: { label: 'Date', type: 'datetime' },
			from_box_name: { label: 'From Box' },
			to_box_name: { label: 'To Box' },
			user_name: { label: 'User' }
		}
	},
	'unit-transfers': {
		model: null,
		filterOptions: [{ column: 'created_on', displayName: 'Transferred At', type: 'datetime' }],
		endpoint: { table: 'box_transfer', method: 'report' },
		columns: {
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			created_on: { label: 'Date', type: 'datetime' },
			from_unit_name: { label: 'From Unit' },
			to_unit_name: { label: 'To Unit' },
			user_name: { label: 'User' },
			witness_name: { label: 'Verified By' }
		}
	},

	'drug-checks': {
		model: null,
		noBrowser: true,
    endpoint: { table: 'drug_check', method: 'filter' },
    columns: {
			type: { label: 'Type' },
			drug__barcode_id: { label: 'Code' },
			created_on: { label: 'Date', type: 'datetime' },
			user_name: { label: 'Checked By' },
			scanned_manually: {
				label: 'Method',
				type: 'boolean',
				alteration: function(scannedManually) {
					return scannedManually ? 'Manual Check' : 'Scanned';
				}
			},
			witnessed_by: { label: 'Verified By' },
			unit__name: { label: 'Unit' },
			drug_box__name: { label: 'Drug Box' },
			guest_verify__name: { label: 'Guest Verifier' },
			guest_verify__title: { label: 'Guest Title' },
			guest_verify__license_number: { label: 'Guest License #' }
		}
	},
	'box-checks': {
		model: null,
		filterOptions: [{ column: 'created_on', displayName: 'Date', type: 'datetime' }],
		endpoint: { table: 'box_check', method: 'report' },
		columns: {
			drug_box__barcode_id: { label: 'Current Box Code' },
			reseal_box_barcode_id: { label: 'Reseal Box Code' },
			created_on: { label: 'Date', type: 'datetime' },
			user_name: { label: 'Checked By' },
			scanned_manually: {
				label: 'Method',
				type: 'boolean',
				alteration: function(scannedManually) {
					return scannedManually ? 'Manual Check' : 'Scanned';
				}
			},
			witnessed_by: { label: 'Verified By' },
			unit__name: { label: 'Unit' },
			drug_box__name: { label: 'Drug Box' },
			notes: { label: 'Notes' }
		}
	},
	expiring: {
		model: null,
		filterOptions: [
			{ column: 'expiration_date', displayName: 'Expires', type: 'datetime' },
			{
				column: 'type',
				displayName: 'Drug Type',
				options: 'will be set by component'
			}
		],
		endpoint: { table: 'drug', method: 'expiring' },
		date_field: 'expiration_date',
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			unit__name: { label: 'Unit' },
			stock_move_record__quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expires At', type: 'date' }
		}
	},
	expired: {
		model: null,
		filterOptions: [
			{ column: 'expiration_date', displayName: 'Expired', type: 'datetime' },
			{
				column: 'type',
				displayName: 'Drug Type',
				options: 'will be set by component'
			}
		],
		endpoint: { table: 'drug', method: 'expired' },
		date_field: 'expiration_date',
		sort: { column: 'expiration_date', direction: 'desc' },
		columns: {
			type: { label: 'Type' },
			barcode_id: { label: 'Code' },
			drug_box__name: { label: 'Drug Box' },
			unit__name: { label: 'Unit' },
			stock_move_record__quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			lot_number: { label: 'Lot Number' },
			expiration_date: { label: 'Expired At', type: 'date' }
		}
	},
	discrepancy: {
		model: null,
		endpoint: { table: 'discrepancy', method: 'all' },
		date_field: 'created_on',
		columns: {
			discrepancy_type: { label: 'Discrepancy' },
			quantity: {
				label: 'Dosage',
				type: 'volume',
				alteration: function(v) {
					return Math.abs(parseFloat(v));
				}
			},
			type: { label: 'Type' },
			notes: { label: 'Notes' },
			user_name: { label: 'User' },
			created_on: { label: 'Date', type: 'datetime' }
		}
	},
	'narc-lock-audit-report': {
		model: null,
		multiAgency: false,
		columns: {
			date: { label: 'Event Date', type: 'datetime' },
			lock: { label: 'Lock' },
			person_name: { label: 'Person' },
			key_name: { label: 'Key' },
			description: { label: 'Event' },
		},
		filterOptions: [
			{ column: 'date', displayName: 'Event Date', type: 'datetime' },
			{ column: 'lock', displayName: 'Lock', options: ':build_set'},
			{ column: 'person_name', displayName: 'Person', options: ':build_set'},
			{ column: 'key_name', displayName: 'Key', options: ':build_set'},
		],
		endpoint: { table: 'narc_lock_integration', method: 'lock_lock_audit_report' },
		date_field: 'date',
		sort: { column: 'date', direction: 'desc' }
	},
};

export default reports;



// WEBPACK FOOTER //
// ./src/components/reportContent/reports.js